// 将百分比透明度转换为小数
function disposeOpacity (opacity) {
  if (!opacity) return 1
  return parseFloat(opacity) / 100
}
// 给rgb的值修改为 rgba
function addOpacity (color, opacity) {
  let disposeColor = color
  if (disposeColor && disposeColor.includes('rgb(')) {
    disposeColor = disposeColor.replace('rgb', 'rgba')
    disposeColor = disposeColor.replace(')', `,${disposeOpacity(opacity)})`)
  } else return `rgba(255, 255, 255, ${disposeOpacity(opacity)})`
  return disposeColor
}

// 自定义页面 执行样式设置
let setStyle = {
  computed: {
    // 设置背景色
    getBgc () {
      return (background, item) => {
        if (item && item.type === 'decorate') {
          return 'transparent'
        } else {
          return background && addOpacity(background.backgroundColor, background.opacity)
        }
      }
    },
    getBgcImg () {
      return background => {
        return background && (background.borderStyle ? `url(${background.borderStyle})` : '')
      }
    },
    getBorder () {
      return borderParent => {
        if (!borderParent) return false
        let border = borderParent.border
        // 默认是没有边框的
        return (border.width && border.style && border.color) ? `${border.width} ${border.style} ${border.color}` : 'none'
      }
    },
    getFontStyle () {
      return (fontObj, char) => {
        if (!fontObj) return {}
        let font = fontObj.font
        let fontStyle = fontObj.fontStyle
        let style = {
          'color': font.color,
          'font-size': font.size,
          'font-family': font.family
        }
        if (fontStyle === 'italic') {
          style['font-style'] = 'italic'
        } else if (fontStyle === 'bold') {
          style['font-weight'] = 'bold'
        } else if (fontStyle === 'underline' && !char) {
          style['text-decoration'] = 'underline'
        } else if (fontStyle === 'normal') {
          style['font-style'] = 'normal'
        } else {
          style['font-style'] = 'normal'
          style['font-weight'] = 'normal'
          style['text-decoration'] = 'normal'
        }
        return style
      }
    },
    getCharFontStyle () {
      return fontObj => {
        if (!fontObj) return {}
        let font = fontObj.font
        let fontStyle = fontObj.fontStyle
        let style = {
          'color': font.color,
          'fontSize': parseFloat(font.size),
          'fontFamily': font.family
        }
        if (fontStyle === 'italic') {
          style['fontStyle'] = 'italic'
        } else if (fontStyle === 'bold') {
          style['fontWeight'] = 'bold'
        } else if (fontStyle === 'underline') {
          style['textDecoration'] = 'underline'
        } else if (fontStyle === 'normal') {
          style['fontStyle'] = 'normal'
        } else {
          style['fontStyle'] = 'normal'
          style['fontWeight'] = 'normal'
          style['textDecoration'] = 'normal'
        }
        return style
      }
    }
  }
}
export default setStyle



// WEBPACK FOOTER //
// ./src/components/public/setStyle.js